

const InvoiceData = {
    id: "5df3180a09ea16dc4b95f910",
    
    balance: "$2,283.74",
    fullname: "MANTRIX",
    email: "susanafuentes@mantrix.com",
    phone: "+1 (872) 588-3809",
    address: "922 Campus Road, Drytown, Wisconsin, 1986",
    trans_date: "26-11-2021",
    due_date: "26-11-2021",
    companyID: "10001",
    companyName: "xyz company",
    items: [
        {
            sno: 1,
            desc: "FinePix Pro2 3D Camera",
            qty: 2,
            rate: 1600.00,
        },
        {
            sno: 2,
            desc: "Luxury Ultra thin Wrist Watch",
            qty: 1,
            rate: 300.99,
        },
        {
            sno: 3,
            desc: "Duracell Ultra Alkaline Battery AA, 4 pcs",
            qty: 1,
            rate: 145.99,
        }
    ]
}

export default InvoiceData;